import Cookies from 'js-cookie';
import { encode } from 'base-64';

const SECURE_DEFAULTS = {
  secure: true,
  sameSite: 'Strict',
};

const AUTH_COOKIE_KEYS = [
  'accessToken',
  'role',
  'username',
  'permissions',
  'ispermission',
  'vehicletype',
  'aps_code',
  'csrftoken',
  'is_first_login',
];

export const setUserAuthCookies = (user, options = {}) => {
  if (!user) return;

  const cookieOptions = { expires: 1, ...SECURE_DEFAULTS, ...options };

  const cookieMap = {
    accessToken: encode(user?.token),
    role: encode(user?.role),
    username: encode(user?.username),
    permissions: encode(user?.permissions),
    vehicletype: encode(user?.vehicle_type_master),
    aps_code: encode(user?.aps_code),
  };

  Object.entries(cookieMap).forEach(([key, value]) => {
    Cookies.set(key, value, cookieOptions);
  });

  Cookies.set('ispermission', JSON.stringify(user), cookieOptions);
  Cookies.set('is_first_login', String(user?.is_first_login === true), cookieOptions);
};

export const clearFirstLoginCookie = () => {
  Cookies.remove('is_first_login', SECURE_DEFAULTS);
};

export const clearUserAuthCookies = () => {
  AUTH_COOKIE_KEYS.forEach((key) => Cookies.remove(key, SECURE_DEFAULTS));
  sessionStorage.clear();
  localStorage.clear();
};
